import { postService, getService } from '../../services/httpService';
import { Types } from './types';
import { apiList } from '../../util/apiList';

const startClientsFindAll = () => ({
  type: Types.START_CLIENTS_FIND_ALL,
  payload: {},
});

const endClientsFindAll = (success, error) => ({
  type: Types.END_CLIENTS_FIND_ALL,
  payload: {
    success,
    error,
  },
});

export const clientsFindAll =
  (skip = 0, limit = 10) =>
  async (dispatch) => {
    dispatch(startClientsFindAll());
    const [response, error] = await getService(`${apiList.clients}?skip=${skip}&limit=${limit}`);
    console.log("reducer", response);
    dispatch(endClientsFindAll(response, error));
  };

const startCreateClient = () => ({
  type: Types.START_CREATE_CLIENT,
  payload: {},
});

const endCreateClient = (success, error) => ({
  type: Types.END_CREATE_CLIENT,
  payload: {
    success,
    error,
  },
});

export const createClient = (data) => async (dispatch) => {
  console.log(data, 'data');
  dispatch(startCreateClient());
  const [response, error] = await postService(apiList.clients, data);
  dispatch(endCreateClient(response, error));
};
